import styled from 'styled-components';

import { GetDeliveriesQuery } from 'data/__generated__';

import type { ViewMode } from './index';
import { useDeliverySelection } from './hooks/useDeliverySelection';

import { DeliveryActionBar } from './DeliveryActionBar';
import { DeliveriesTrelloView } from './DeliveriesTrelloView';
import { DeliveriesTimelineView } from './DeliveriesTimelineView';
import { DeliveriesDataTableView } from './DeliveriesDataTableView';

type DeliveriesViewsProps = {
    deliveries: GetDeliveriesQuery['deliveries'];
    viewMode: ViewMode;
};

// Frontière entre le fetch (index.tsx) et les vues : on reçoit la liste déjà filtrée et on porte ici
// la sélection + la barre d'actions, partagées par les trois vues. Chaque vue reste purement
// présentationnelle et ne reçoit que la liste et l'API de sélection.
export const DeliveriesViews = ({ deliveries, viewMode }: DeliveriesViewsProps) => {
    const { selectedDeliveryIds, setSelectedDeliveryIds, toggleDeliverySelection } = useDeliverySelection();

    return (
        <ViewsContainer>
            {viewMode === 'kanban' ? (
                <DeliveriesTrelloView
                    deliveries={deliveries}
                    selectedDeliveryIds={selectedDeliveryIds}
                    setSelectedDeliveryIds={setSelectedDeliveryIds}
                    toggleDeliverySelection={toggleDeliverySelection}
                />
            ) : viewMode === 'timeline' ? (
                <DeliveriesTimelineView
                    deliveries={deliveries}
                    selectedDeliveryIds={selectedDeliveryIds}
                    toggleDeliverySelection={toggleDeliverySelection}
                />
            ) : (
                <DeliveriesDataTableView
                    deliveries={deliveries}
                    selectedDeliveryIds={selectedDeliveryIds}
                    setSelectedDeliveryIds={setSelectedDeliveryIds}
                />
            )}
            <DeliveryActionBar deliveries={deliveries} selectedDeliveryIds={selectedDeliveryIds} />
        </ViewsContainer>
    );
};

const ViewsContainer = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    overflow: hidden;
`;
